import { HTTP } from "@/api";

export default {
  getSocial({ commit }) {
    commit("isLoading", {
      key: "socials",
      status: true
    });
    return HTTP.get("/social").then(res => {
      const data = res.data;
      if (data.success) {
        commit("social", data.result);
      }
      return data.success;
    });
  },
  updateSocial(store, data) {
    return HTTP.post("/social", data).then(res => {
      const data = res.data;
      return data.success;
    });
  }
};
